import React from "react";

/**
 * SourcePlatformBadge — tiny "via TikTok" / "via Instagram" pill.
 *
 * Renders only when a video has been imported from a social platform.
 * Sized to overlay neatly on a thumbnail bottom-left without competing
 * with the platform's own UI chrome (LIVE chip, viewer count, duration).
 *
 * The colours mirror each platform's brand identity at low opacity so
 * the badge is recognisable at a glance but doesn't fight the artwork.
 */
const STYLES = {
  tiktok:    "bg-pink-500/85 text-white",
  instagram: "bg-gradient-to-r from-amber-500/85 via-rose-500/85 to-fuchsia-500/85 text-white",
  youtube:   "bg-red-600/85 text-white",
  twitter:   "bg-neutral-900/90 text-white",
  facebook:  "bg-blue-600/85 text-white",
  vimeo:     "bg-sky-500/85 text-white",
};

export default function SourcePlatformBadge({ platform, label, className = "" }) {
  if (!platform) return null;
  const tone = STYLES[platform] || "bg-neutral-700/85 text-white";
  return (
    <span
      data-testid={`source-badge-${platform}`}
      className={`inline-block text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded backdrop-blur-sm ${tone} ${className}`}
      title={`Imported from ${label || platform}`}
    >
      via {label || platform}
    </span>
  );
}
